import { Icon, IconLinkButton, TextSpan, useFormatDateTime } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { AnalyticsFeedbackEventResource } from "../analyticsTypes";

const Wrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: ${({ theme }) => theme.spacing(8)};
	align-items: flex-start;
`;

const RatingColumn = styled.div`
	display: grid;
	grid-template-columns: max-content 1fr max-content;
	align-items: center;
`;

const StyledIcon = styled(Icon)`
	width: ${({ theme }) => theme.spacing(5)};
	height: ${({ theme }) => theme.spacing(5)};
`;

const Col = styled.div`
	display: grid;
	grid-template-columns: max-content 1fr;
	gap: ${({ theme }) => theme.spacing(1)};
`;

interface Props {
	event: AnalyticsFeedbackEventResource;
}

export const EventInfo: FC<Props> = ({ event }) => {
	const { t } = useTranslation();
	const formatDateTime = useFormatDateTime();

	return (
		<Wrapper>
			<div>
				<TextSpan $fontWeight="bold" $size="large">
					{event.name}
				</TextSpan>
				<div>
					<TextSpan $size="small">
						{`${formatDateTime(event.start, { dateStyle: "short" })} - ${formatDateTime(event.end, { dateStyle: "short" })}`}
					</TextSpan>
				</div>
			</div>
			<RatingColumn>
				<TextSpan $fontWeight="bold" $size="large">{`${t("Total rating")}: ${event.rating ?? "-"}`}</TextSpan>
				<StyledIcon $icon="star_filled" />
				<IconLinkButton
					to={`/events/active/${event.id}/details`}
					size="small"
					icon="arrow_outward"
					title={t("To event")}
					type="button"
				/>
			</RatingColumn>
			<Col>
				<TextSpan $fontWeight="bold">{`${t("Event type")}: `}</TextSpan>
				<TextSpan>{event.eventTypeName}</TextSpan>
				<TextSpan $fontWeight="bold">{`${t("Creator")}: `}</TextSpan>
				<TextSpan>{event.creatorName ?? "-"}</TextSpan>
				<TextSpan $fontWeight="bold">{`${t("Location")}: `}</TextSpan>
				<TextSpan>{event.locationName ?? "-"}</TextSpan>
			</Col>
			<Col>
				<TextSpan $fontWeight="bold">{`${t("Participants count")}: `}</TextSpan>
				<TextSpan>{event.participantsCount ?? "-"}</TextSpan>
				<TextSpan $fontWeight="bold">{`${t("Feedback count")}: `}</TextSpan>
				<TextSpan>{event.feedbackCount}</TextSpan>
				<TextSpan $fontWeight="bold">{`${t("Feedback templates")}: `}</TextSpan>
				<TextSpan>{event.feedbackEvaluation.map((evaluation) => evaluation.feedback.name).join(", ")}</TextSpan>
			</Col>
		</Wrapper>
	);
};
